import { createIdFactory } from '@runloop/reflex-contract';

export const ids = createIdFactory({
  policy: 'npl',
} as const);
